import { z } from 'zod';

import { CODE_DIGITS_PATTERN, PRODUCT_CODE_PATTERN } from '../helper/productCode';

export const SN_PRODUCT_MAPPING_FIELD_LABELS = {
  customerId: '客戶',
  prefix: '客戶代碼',
  codeDigits: '數字段',
  productCode: '產品代碼',
  productName: '產品名稱',
  remark: '備註',
};

export const snProductMappingFormSchema = z.object({
  identityLocked: z.boolean(),
  customerId: z.string().nullable().optional(),
  prefix: z.string(),
  codeDigits: z.string(),
  productCode: z.string(),
  productName: z.string().trim().min(1, '請輸入產品名稱'),
  remark: z.string(),
}).superRefine((values, ctx) => {
  if (values.identityLocked) {
    return;
  }

  if (values.customerId) {
    if (!values.prefix) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['prefix'],
        message: '請選擇客戶代碼。若此客戶沒有 SN 前綴，請先不要指定客戶',
      });
    }
    if (!CODE_DIGITS_PATTERN.test(String(values.codeDigits ?? '').trim())) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['codeDigits'],
        message: '請輸入 3 到 4 碼數字',
      });
    }
    return;
  }

  const productCode = String(values.productCode ?? '').trim().toUpperCase();
  if (!PRODUCT_CODE_PATTERN.test(productCode)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['productCode'],
      message: '產品代碼須為 2～3 碼大寫英文加上 3～4 碼數字',
    });
  }
});
